// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3L4U_","colMin":"styles_colMin__3puhp"};